<div #stackedBarChart [style.height]="legend().length ? 'calc(100% - 27px)' : '100%'" style="width: 100%; position: relative;" class="stacked-bar-chart-container"></div>

@if (legend().length) {
  <div class="list-button">
    <ul class="graph-point">
      @for (item of legend(); track item) {
      <li [title]="item?.legend || ''">
          <div class="legend-color" [style.backgroundColor]="item?.color || 'gray'"></div>{{item?.legend || ''}}
      </li>
      }
    </ul>
  </div>
}
